import React from 'react';

import { useParams } from 'react-router';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { LojaListSecoesComp, LojaSecaoFormComp } from 'pages/cadastro/secoes/components';
import { GrupoExibicaoProvider } from 'pages/cadastro/secoes/contexts/GrupoExibicaoContext';

export function LojaSecaoForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();

    if (!hasFormPermission('SECAO_GERENCIAR', id)) return alertNotPermission();

    return (
        <GrupoExibicaoProvider>
            <FormProvider>
                <LojaSecaoFormComp />
            </FormProvider>
        </GrupoExibicaoProvider>
    );
}

export function LojaListSecoes() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['SECAO_DADOS_ALTERAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <LojaListSecoesComp />
        </ListagemProvider>
    );
}
